// extracted by mini-css-extract-plugin
export default {"chartContainer":"ReadinessGauge_chartContainer__aN+h2","chartTitle":"ReadinessGauge_chartTitle__-KSaO","gaugeWrapper":"ReadinessGauge_gaugeWrapper__DpXWV"};